import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import { imgBase, updMasterCategoryBGReq, rmMasterCategoryBGReq, rmMasterCategoryClrReq, updMasterCategoryClrReq, getMasterCategoryReq, addMasterCategoryReq, updMasterCategoryReq, rmMasterCategoryReq } from '../config/httpRoutes';
import { Row, Form, Col, Card, Button, OverlayTrigger, Tooltip, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox, faEdit, faFileImage, faPaintBrush, faPlus, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/loader';
import TextInput from '../components/textInput';
import SelectInput from '../components/selectInput';
import { defImg } from '../config/globals';
import HeadingImageUploader from "./../components/ImageUpload";

const categoryDesignTypes = ['NONE',
	'categoryGrid',
	'categoryCarousel',
	'FeaturedCategories',
	'grid2x2',
	'quickpick',
	'grid2x3',
	'singleProductCard',
	'festival',
	'priceproductbox',
	'productbox',
	'bannerCarousel',
	'newlyLounched',
	'cleaning',
	'cleaningBgImage',
	'newlyLounchedWithBgImage',
	'containerBgImage'
];

class Categories extends React.Component {
	constructor(props) {
		super(props);

		this.imgInputRef = React.createRef();

		this.state = {
			name: '',
			image: '',
			img: null,
			design_type: '',
			sequence: '',
			is_show: false,
			extras: { heading: '', subheading: '', powerdby: '', bgupperbackgroundcolor: '', bglowerbackgroundcolor: '', backGroundColor: '', headingImageBgColor: '', buttonColor: '' },
			categories: null,
			errors: { name: '', pincode: '' },
			loading: false,
			deleteLoading: false,
			fetchLoading: true,
			form: false,
			id: '',
			bg_cid: '',
		};
	}

	componentDidMount() {
		this.getCategories();
	}

	getCategories = () => {
		this.setState({ fetchLoading: true });
		getMasterCategoryReq()
			.then((res) => {
				this.setState({ categories: res.data, form: false });
				res.data.forEach((cat) => {
					this[`bgImgInput${cat.name}`] = React.createRef();
					this[`bgClrInput${cat.name}`] = React.createRef();
				});
			}).catch((err) => {
				alertError(err.response?.data?.msg || "Could not fetch categories");
			}).finally(() => {
				this.setState({ fetchLoading: false });
			});
	}

	rmCategory = (id, index) => {
		this.setState({ deleteLoading: true });
		rmMasterCategoryReq({ id })
			.then((res) => {
				const { categories } = this.state;
				categories.splice(index, 1);
				this.setState({ categories });
			}).catch((err) => {
				alertError(err.response?.data?.msg || "Could not remove category");
			}).finally(() => {
				this.setState({ deleteLoading: false });
			});
	}

	handleChange = ({ target: { name, value } }) => {
		if (name === 'sequence') {
			this.setState({ [name]: ((parseInt(value) || '').toString()) || '' });
		} else if (name.startsWith('extras.')) {
			const key = name.split('.')[1];
			this.setState((prevState) => ({
				extras: {
					...prevState.extras,
					[key]: value,
				},
			}));
		} else {
			this.setState({ [name]: value });
		}
	}

	validate = () => {
		const { name } = this.state;
		let errors = { name: '' }, isValid = true;

		if (!name) {
			errors.name = "Enter name to continue";
			isValid = false;
		}

		this.setState({ errors });
		return isValid;
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { id, name, design_type, image, img, sequence, is_show, extras } = this.state;
		if (this.validate()) {
			if (id) {
				this.setState({ loading: true });
				const formData = new FormData();
				formData.append('id', id);
				formData.append('name', name);
				formData.append('design_type', design_type);
				formData.append('sequence', sequence);
				formData.append('is_show', is_show);
				formData.append('img', img);
				formData.append('image', img ? img.name || `${name}.${img.type.split("/")[1]}` : image);
				Object.keys(extras).forEach(key => formData.append(`extras[${key}]`, extras[key]));
				updMasterCategoryReq(formData)
					.then((res) => {
						this.setState({ loading: false });
						alertSuccess("Master Category updated");
						this.getCategories();
					}).catch((err) => {
						this.setState({ loading: false });
						alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
					});
			} else {
				this.setState({ loading: true });
				const formData = new FormData();
				formData.append('name', name);
				formData.append('design_type', design_type);
				formData.append('sequence', sequence);
				formData.append('is_show', is_show);
				formData.append('img', img);
				formData.append('image', img ? img.name || `${name}.${img.type.split("/")[1]}` : image);
				Object.keys(extras).forEach(key => formData.append(`extras[${key}]`, extras[key]));
				addMasterCategoryReq(formData)
					.then((res) => {
						this.setState({ loading: false });
						alertSuccess("Master Category added");
						this.getCategories();
					}).catch((err) => {
						this.setState({ loading: false });
						alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
					});
			}
		}
	}

	navigateAdd = () => {
		this.setState({
			id: '',
			name: '',
			design_type: '',
			sequence: '',
			img: null,
			image: '',
			is_show: false,
			extras: { heading: '', subheading: '', powerdby: '', bgupperbackgroundcolor: '', bglowerbackgroundcolor: '' },
			errors: { name: '' },
			loading: false,
			form: true
		});
	}

	navigateEdit = (id, name, image, design_type, sequence, is_show, extras = {}) => {
		const defaultExtras = { heading: '', subheading: '', powerdby: '', bgupperbackgroundcolor: '', bglowerbackgroundcolor: '' };
		console.log("extras:", extras)
		this.setState({
			id,
			name,
			image,
			design_type,
			sequence,
			is_show,
			img: null,
			extras: { ...defaultExtras, ...extras },
			errors: { name: '' },
			loading: false,
			form: true
		});
	}

	navigateSubcategory = (id) => {
		this.props.history.push(`/sub-categories/${id}`);
	}

	onChangeFile = (e) => {
		if (e.target.files.length > 0) {
			let fileName = e.target.files[0].name;
			this.getBase64(e.target.files[0], (res) => {
				this.setState({ [e.target.name]: res, /* image: fileName, */ img: e.target.files[0] });
			});
		}
	}

	getBase64 = (file, cb) => {
		let reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = function () {
			cb(reader.result)
		};
		reader.onerror = function (error) {
			console.log('Error: ', error);
		}
	}

	onChangeBG = (e, cid) => {
		if (e.target.files.length > 0) {
			this.uploadBG(cid, e.target.files[0]);
		}
	}

	uploadBG = (id, img) => {
		const formData = new FormData();
		formData.append('id', id);
		formData.append('img', img);
		updMasterCategoryBGReq(formData)
			.then((res) => {
				alertSuccess("Category background image updated");
				this.getCategories();
			}).catch((err) => {
				alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
			});
	}

	rmBG = (id) => {
		rmMasterCategoryBGReq({ id })
			.then((res) => {
				alertSuccess("Category background image removed");
				this.getCategories();
			}).catch((err) => {
				alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
			});
	}

	onChangeClr = (e, id) => {
		if (e.target.value) {
			this.updateClr(id, e.target.value);
		}
	}

	updateClr = (id, color) => {
		updMasterCategoryClrReq({ id, color })
			.then((res) => {
				alertSuccess("Category background color updated");
				this.getCategories();
			}).catch((err) => {
				alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
			});
	}

	rmClr = (id) => {
		rmMasterCategoryClrReq({ id })
			.then((res) => {
				alertSuccess("Category background color removed");
				this.getCategories();
			}).catch((err) => {
				alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
			});
	}

	getFieldsByDesignType = (design_type) => {
		switch (design_type) {
			case 'festival':
				return ['heading', 'subheading', 'powerdby', 'bgupperbackgroundcolor', 'bglowerbackgroundcolor'];
			case 'newlyLounchedWithBgImage':
				return ['heading', 'headingImage', 'subheading', 'backGroundColor', 'headingImageBgColor', 'buttonColor'];
			case 'cleaningBgImage':
			case 'priceproductbox':
			case 'productbox':
			case 'quickpick':
			case 'newlyLounched':
			case 'FeaturedCategories':
			case 'cleaning':
				return ['heading', 'subheading'];
			default:
				return [];
		}
	}

	render() {
		const { id, name, image, design_type, sequence, is_show, img, extras, categories, deleteLoading, errors, loading, fetchLoading, form } = this.state;
		const { handleChange, handleSubmit, navigateAdd, navigateEdit, rmCategory, navigateSubcategory, onChangeFile, imgInputRef, onChangeBG, rmBG, onChangeClr, rmClr } = this;

		const currentFields = this.getFieldsByDesignType(design_type);

		return (
			form ?
				<Row style={{ marginLeft: 0, marginRight: 0 }}>
					<Col md={{ span: 4, offset: 4 }} lg={{ span: 4, offset: 4 }} xs={12}>
						<Card style={{ marginTop: '20%' }}>
							<Card.Header>
								<Card.Title style={{ textAlign: 'center' }}>{id ? 'Update ' : 'Add '} Category</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={handleSubmit}>
									<Form.Group style={{ position: 'relative' }}>
										<Form.Control name="image" onChange={onChangeFile} type="file" style={{ display: 'none' }} ref={imgInputRef} />
										{image ?
											img ?
												<>
													<Image fluid style={{ marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer' }} onClick={() => { imgInputRef.current.click() }} src={image} />
													<button type="button" className="btn-success btn btn-circle" style={{ position: 'absolute', right: '25%', bottom: 0 }} onClick={() => { imgInputRef.current.click() }}>
														<FontAwesomeIcon icon={faPlus} />
													</button>
												</>
												:
												<>
													<Image fluid style={{ marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer' }} onClick={() => { imgInputRef.current.click() }} src={`${imgBase}${image}`} />
													<button type="button" className="btn-success btn btn-circle" style={{ position: 'absolute', right: '25%', bottom: 0 }} onClick={() => { imgInputRef.current.click() }}>
														<FontAwesomeIcon icon={faPlus} />
													</button>
												</>
											:
											<>
												<Image fluid style={{ marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer' }} src={defImg} />
												<button type="button" className="btn-success btn btn-circle" style={{ position: 'absolute', right: '25%', bottom: 0 }} onClick={() => { imgInputRef.current.click() }}>
													<FontAwesomeIcon icon={faPlus} />
												</button>
											</>
										}
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={name} error={errors.name} name="name" label="Name" />
									</Form.Group>

									<Form.Group>
										<SelectInput onChange={handleChange} value={design_type} name="design_type" label="Design Type" options={categoryDesignTypes} />
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={sequence} name="sequence" label="Sequence" />
									</Form.Group>

									<Form.Group>
										<SelectInput onChange={handleChange} value={is_show} name="is_show" label="Show " options={["Yes", "No"]} />
									</Form.Group>

									{
										currentFields.includes('headingImage') &&
										<HeadingImageUploader />
										// <Form.Group style={{ position: 'relative' }}>
										// 	<Form.Control name="image" onChange={onChangeFile} type="file" style={{ display: 'none' }} ref={imgInputRef} />
										// 	{extras['headingImage'] ?
										// 		<>
										// 			<Image fluid style={{ marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer' }} onClick={() => { imgInputRef.current.click() }} src={`${imgBase}${image}`} />
										// 			<button type="button" className="btn-success btn btn-circle" style={{ position: 'absolute', right: '25%', bottom: 0 }} onClick={() => { imgInputRef.current.click() }}>
										// 				<FontAwesomeIcon icon={faPlus} />
										// 			</button>
										// 		</>
										// 		: <>
										// 			<Image fluid style={{ marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer' }} src={defImg} />
										// 			<button type="button" className="btn-success btn btn-circle" style={{ position: 'absolute', right: '25%', bottom: 0 }} onClick={() => { imgInputRef.current.click() }}>
										// 				<FontAwesomeIcon icon={faPlus} />
										// 			</button>
										// 		</>
										// 	}
										// </Form.Group>
									}
									{currentFields.map(field => (
										<Form.Group key={field}>
											<TextInput
												onChange={handleChange}
												value={extras[field]}
												name={`extras.${field}`}
												label={field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, ' $1')}
											/>
										</Form.Group>
									))}

									<Button variant="success" type="submit" style={{ marginLeft: '30%', width: '40%', marginTop: '25px' }} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
											:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
				:
				<Row style={{ marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%' }}>
					<Col md={12} style={{ justifyContent: 'flex-end', display: 'flex', marginTop: '10px', marginBottom: '15px' }}>
						<Button variant="success" onClick={navigateAdd} size="md">
							<FontAwesomeIcon icon={faPlus} /> Add Category
						</Button>
					</Col>
					{fetchLoading && <Loader />}
					{Array.isArray(categories) ?
						categories.length > 0 ?
							<div className="table-responsive">
								<table className="table table-hover table-attendance">
									<thead>
										<tr>
											<th>Sequence</th>
											<th>Image</th>
											<th>Name</th>
											<th>Background Image</th>
											<th>Background Color</th>
											<th>Design Type</th>
											<th>Show</th>
											<th className="th1">Action</th>
										</tr>
									</thead>
									<tbody>
										{categories.map(({ id, name, image, design_type, background_image, background_color, sequence, is_show, extras }, i) =>
											<tr key={i}>
												<td>{sequence}</td>
												<td>
													{image ?
														<Image fluid style={{ width: 50, height: 50 }} src={`${imgBase}${image}`} />
														:
														"No Image"
													}
												</td>
												<td>{name}</td>
												<td>
													{background_image ?
														<>
															<Image fluid style={{ width: 50, height: 50 }} src={`${imgBase}${background_image}`} />
															<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
																<FontAwesomeIcon icon={faTrashAlt} className="ml-2 disabled-icon font-16 cursor-pointer" onClick={(e) => { rmBG(id) }} />
															</OverlayTrigger>
														</>
														:
														"No Background Image"
													}
												</td>
												<td>
													{background_color ?
														<div className='d-flex align-items-center'>
															<div style={{ backgroundColor: background_color, height: 20, width: 20, marginRight: 10 }} />
															{background_color}
															<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
																<FontAwesomeIcon icon={faTrashAlt} className="ml-2 disabled-icon font-16 cursor-pointer" onClick={(e) => { rmClr(id) }} />
															</OverlayTrigger>
														</div>
														:
														"No Background Color"
													}
												</td>
												<td>{design_type}</td>
												<td>{is_show == true ? "Yes" : "No"}</td>
												<td className="text-center">
													<div className="course-control-box icons-container d-flex">
														<OverlayTrigger overlay={<Tooltip>Edit</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faEdit} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateEdit(id, name, image, design_type, sequence, is_show == true ? "Yes" : "No", extras) }} />
														</OverlayTrigger>
														<OverlayTrigger overlay={<Tooltip>Categories</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faBox} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateSubcategory(id) }} />
														</OverlayTrigger>
														<input name="bg_image" onChange={(e) => { onChangeBG(e, id) }} type="file" style={{ display: 'none' }} ref={this[`bgImgInput${name}`]} />
														<OverlayTrigger overlay={<Tooltip>Upload Background Image</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faFileImage} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { this[`bgImgInput${name}`].current.click() }} />
														</OverlayTrigger>
														<input name="bg_color" onChange={(e) => { onChangeClr(e, id) }} type="color" style={{ display: 'none' }} ref={this[`bgClrInput${name}`]} />
														<OverlayTrigger overlay={<Tooltip>Update Background Color</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faPaintBrush} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { this[`bgClrInput${name}`].current.click() }} />
														</OverlayTrigger>
														<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
															<FontAwesomeIcon icon={faTrashAlt} className="disabled-icon font-16 cursor-pointer" onClick={(e) => { rmCategory(id, i) }} />
														</OverlayTrigger>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
							:
							<p style={{ position: 'fixed', marginLeft: '34%', marginTop: '20%' }}>No categories found.</p>
						:
						<></>
					}
				</Row>
		);
	}
}

export default Categories;
